import React, { useMemo } from 'react';
import Styles from './FinalMessage.css';
import ContainerHome24 from '../../../../components/atoms/ContainerHome24';
import Button from '../../widgets/Button/Button';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import { SIMULATION_STEPS } from '../../model/simulation-steps';
import { useScroll } from '../../../../utils/useLayout';
import clsx from 'clsx';

function FinalMessage() {
  const { scrollToTop } = useScroll();
  const { simulationStep, restartSimulation, proposalId, selectedStore } =
    useSimuladorEnergiaSolarState();

  const visible = simulationStep?.id === SIMULATION_STEPS.END_JOURNEY_FINAL.id;
  const variant = simulationStep?.variant;

  const currentVariant = useMemo(() => {
    if (!visible) return null;

    const options = {
      'proposal-sent': {
        RenderImg: (
          <>
            <source
              media="(min-width: 992px)"
              srcSet="assets/simulador-energia-solar/jornada/proposal-sent-desk.svg"
            />
            <img src="assets/simulador-energia-solar/jornada/proposal-sent.svg" alt="" />
          </>
        ),
        title: 'Agora é com a gente! Proposta enviada',
        description:
          'Estamos avaliando a proposta e em breve você receberá um resultado via SMS e e-mail conforme cadastrados e com os próximos passos.',
      },
      'proposal-failed': {
        RenderImg: (
          <img src="assets/simulador-energia-solar/jornada/proposal-not-approved.svg" alt="" />
        ),
        title: 'Sua proposta não foi aprovada neste momento',
        description: 'Você pode tentar novamente com novas condições ou um novo perfil de crédito.',
      },
      'proposal-approved': {
        RenderImg: (
          <>
            <source
              media="(min-width: 992px)"
              srcSet="assets/simulador-energia-solar/jornada/proposal-sent-desk.svg"
            />
            <img src="assets/simulador-energia-solar/jornada/proposal-sent.svg" alt="" />
          </>
        ),
        title: 'Proposta aprovada',
      },
    };

    return options[variant] || null;
  }, [variant, visible]);

  if (!visible || !currentVariant) return null;

  return (
    <>
      <div
        id="final-message"
        className={clsx({
          'final-message': true,
          [`${variant}`]: true,
        })}
      >
        <ContainerHome24>
          <div className="content-wrapper">
            <div className="content-img">
              <picture className="img-proposal">{currentVariant.RenderImg}</picture>
            </div>

            <div className="content-text">
              <h6 className="text-title">{currentVariant.title}</h6>

              {currentVariant.description && (
                <p className="text-description">{currentVariant.description}</p>
              )}

              {variant === 'proposal-approved' && (
                <>
                  <p className="text-description">
                    Você está mais próximo de ser sustentável e economizar na sua conta de energia.
                  </p>

                  <p className="text-description bold">Próximo passo:</p>

                  <p className="text-description">
                    Vá até a loja que fez o orçamento e apresente o número da proposta abaixo para
                    dar andamento.
                  </p>

                  <div className="box-proposal">
                    <div className="box-row">
                      <img src="assets/simulador-energia-solar/jornada/ic-proposal.svg" alt="" />
                      <p>Proposta</p>
                    </div>
                    <p className="box-text">{proposalId}</p>
                    <div className="box-row">
                      <img src="assets/simulador-energia-solar/jornada/ic-location.svg" alt="" />
                      <p>Loja</p>
                    </div>
                    <p className="box-text">
                      {selectedStore?.name}
                      <br />
                      {selectedStore?.addressLabel}
                      <br />
                      {selectedStore?.phone}
                    </p>
                  </div>
                </>
              )}

              <Button
                id="btn-goto-initial-page"
                variant="red"
                onClick={(ev) => {
                  ev.preventDefault();

                  scrollToTop();
                  restartSimulation();
                }}
              >
                Ir para a página inicial
              </Button>
            </div>
          </div>
        </ContainerHome24>
      </div>

      <style jsx>{Styles}</style>
    </>
  );
}

export default FinalMessage;
